import React from 'react'
import Skeleton from '../ui/Skeleton'

const BoxLoaders = ({view}) => {
  const skeletons = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; 
  
  return (
    <div style={view==='grid' ? styles.containerGrid : styles.containerList}>
      {skeletons.map((skeleton, index) => (
        <div key={index} style={styles.skeletonWrapper}>
          <Skeleton height={view==='grid' ? "150px" : "50px"}/>
        </div>
      ))}
    </div>
  )
}

const styles = {
  containerGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)', // 4 columnas
    gap: '20px',
    padding: '20px 80px',
  },
  containerList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)', 
    gap: '20px',
    padding: '20px 80px',
  },
  skeletonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

export default BoxLoaders
